var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('myheader'),_c('router-view'),_c('myfooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('div',{staticClass:"preloader-inner"},[_c('div',{staticClass:"preloader-icon"},[_c('span'),_c('span')])])])
}]

export { render, staticRenderFns }